import styled from '@emotion/styled';
import {mixinSVGIcon} from 'webapp-lib/styling';

export const DropInfoBox = styled.div`
  display: flex;
  z-index: var(--zindex-snackbar);
  position: absolute;
  bottom: var(--gutter);
  left: 50%;
  align-items: center;
  height: var(--snackbar-height);
  margin: 0 auto;
  padding: 0 var(--gutter) 0 var(--gutter-small);
  border-radius: var(--popover-border-radius);
  color: var(--color-core-white);
  font-weight: var(--snackbar-font-weight);
  font-size: var(--font-size-small);
  background-color: var(--color-menu-border-focus);
  transform: translateX(-50%);

  svg {
    ${mixinSVGIcon}
    fill: var(--color-core-white);
    margin-right: var(--gutter-small);
  }
`;
